<template>
  <page
    layout="single"
    class="rentalResidence"
    no-padding
  >
    <div class="rentalResidence__title">
      <md-icon name="info" />

      <h4>Ma résidence</h4>
    </div>

    <h4 class="rentalResidence__name">Résidence les Bruyères</h4>
    <p>2 rue du petit marteau, 35000 RENNES</p>
    <div
      class="rentalResidence__image"
      style="background-image: url('https://picsum.photos/200/300')"
    />

    <div class="rentalResidence__phones">
      <p>Pour le reste de ce bloc, j'attends l'API, c'est un enchaînement de textes, mais ça ne sert à rien de les intégrer tant que je ne connais pas le format des données fournies par l'API.</p>
    </div>
  </page>
</template>

<script>
export default {
  name: 'RentalResidence'
}
</script>

<style lang="scss" scoped>
$c: '.rentalResidence';

#{$c} {
  padding: 26px !important;
  line-height: 200%;

  &__title {
    display: flex;

    i {
      position: relative;
      top: 5px;
    }

    h4 {
      padding-left: 5px;
      font-size: 22px !important;
    }
  }

  &__name {
    margin-top: 24px;
  }

  &__image {
    height: 250px;
    width: 100%;
    background-size: cover;
    background-position: 50% 50%;
  }

  p {
    margin: 0;
  }

  &__phones {
  }
}
</style>